module.exports = __webpack_public_path__ + "img/shj-icon.e09cad26.png";